(function () {
  // Shopify's native collection sort_by only supports a fixed set of keys
  // (best-selling, price, title, created, manual) — "biggest discount" isn't
  // one of them and can't be added to collection.sort_options via Liquid, so
  // this can't be a real option in the native sort dropdown without it being
  // silently ignored server-side. Instead: a standalone toggle that reorders
  // the already-rendered grid client-side.
  //
  // Discount is read from data-cc-discount, set server-side in Liquid
  // (sections/main-collection.liquid, search-results.liquid) straight from
  // product.compare_at_price vs product.price — NOT scraped from the
  // rendered price markup. Confirmed live that .compare-at-price doesn't
  // actually render on these cards even for products that genuinely have a
  // compare_at_price set (a separate, pre-existing quirk of how/when this
  // theme's price block decides to show the strikethrough), so DOM-scraping
  // would have silently found zero sale items and never shown the button.
  function discountOf(item) {
    var d = item.getAttribute('data-cc-discount');
    return d ? parseInt(d, 10) : 0;
  }

  function init() {
    var sortBar = document.querySelector('.sorting-filter');
    var grid = document.querySelector('.product-grid');
    if (!sortBar || !grid) return;
    var items = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.classList && el.classList.contains('product-grid__item');
    });
    if (!items.length || !grid.querySelector('[data-cc-discount]')) return; // nothing on sale here — don't clutter the sort bar

    items.forEach(function (it, i) { it.dataset.ccOrigOrder = i; });

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cc-sale-sort';
    btn.textContent = '🔥 Sale: High to Low';
    sortBar.insertAdjacentElement('afterend', btn);

    var active = false;
    btn.addEventListener('click', function () {
      active = !active;
      btn.classList.toggle('is-on', active);
      var current = Array.prototype.slice.call(grid.children).filter(function (el) {
        return el.classList && el.classList.contains('product-grid__item');
      });
      var ordered = active
        ? current.slice().sort(function (a, b) { return discountOf(b) - discountOf(a); })
        : current.slice().sort(function (a, b) { return (+a.dataset.ccOrigOrder) - (+b.dataset.ccOrigOrder); });
      ordered.forEach(function (el) { grid.appendChild(el); });
      if (window.ccTrack) window.ccTrack('nav_click', { section: 'sale_sort', page: active ? 'on' : 'off' });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
